module.exports = __webpack_public_path__ + "static/media/helpline.8b3b818c.svg";